export const notifications = 'You could be getting notifications from';
export const agenciesInCounty = 'agencies in your county';
export const getMoreNotifications = 'Get More Notifications';
export const subscribeNow = 'Subscribe Now';
